import React from 'react'
import PropTypes from 'prop-types'

const LoadingSpinner = ({wrapperStyles = {}, spinnerStyles = {}, ...rest}) => {
    return (
        <div
            className="absolute inset-0 z-50 flex items-center justify-center bg-white/80"
            style={wrapperStyles}
            {...rest}
        >
            <div
                className="h-10 w-10 animate-spin rounded-full border-4 border-current border-t-transparent"
                style={spinnerStyles}
            />
        </div>
    )
}

LoadingSpinner.propTypes = {
    wrapperStyles: PropTypes.object,
    spinnerStyles: PropTypes.object
}

export default LoadingSpinner
